/******************************************************************************
 *
 * Copyright (c) 2019-2022 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by 'Shivam Mishra' <shivam.mishra@wakencode.com>, June 2022
 *
 *****************************************************************************/

import React from "react";
import { string } from "../constant/string";

// Styles for footer
const Styles = {
  footerText: {
    fontSize: "1.5rem",
    color: "#595959",
  },
  footerEmail: {
    fontSize: "1.5rem",
    color: "#88a13b",
    marginLeft: "0.5rem",
    textDecoration: 'none'
  },
};

const Footer = () => {
  return (
    //Footer in final pages
    <div className="footer-wrapper">
      <div className="footer-text">
        {string.IN_CASE_OF_ANY_ISSUES_PLEASE_REACH_OUT_TO_US_ON_BELOW_EMAIL}
      </div>{" "}
      <div>
        {" "}
        {/* Redirect to mail */}
        <a className="footer-email" href="mailto:support@myserviceactivator.com">
          {string.HELPMYSERVICEACTIVATORCOM}
        </a>{" "}
      </div>
    </div>
  );
};

export default Footer;
